import { format } from 'date-fns';
import type { MultiLang } from '../../../../config';

interface Props {
    lang: MultiLang;
    date: number;
    onlyDate?: boolean;
}

const DateTime = (props: Props) => {
    const { date, onlyDate } = props;
    const pattern = onlyDate ? 'MMM d, y' : 'MMM d, y HH:mm:ss';
    return <span>{format(new Date(date * 1000), pattern)}</span>;
};

export default DateTime;
